module.exports = __webpack_public_path__ + "img/type_WATER.aa9f8ef3.png";